let sliderdata = {};

sliderdata.hu = {
	DEFAULTSLIDES: [
		{
			type: "nav",
			img_url: "static/graphics/02_add_user.png",
			h2: "NAV online adatszolgáltatás beállítása",
			h3: "2021. január 1-től minden kiállított számláról online adatszolgáltatást kell küldeni a NAV-nak!",
			p: "Ezt a számlakiállítást követően az eBIZ rendszere automatikusan megoldja helyetted, ha beállítod az aláírókulcsod az eBIZ-be! A beállításhoz ügyfélkapu hozzáférés szükséges.",
			aSame: "invoice#/nav-disclaimer",
			a2: "https://www.otpebiz.hu/navreg",
			linktext: "Beállítom most",
			linktext_2: "Regisztráció lépésről lépésre"
		},
		{
			type: "coupon",
			img_url: "static/graphics/08_kupon.png",
			h2: "Szolgáltató aktiválása",
			h3: "Céged eBIZ fiókjához egyedi funkciók elérhetőek.<br />  Aktiváld a szolgáltatótól kapott aktivációs kódoddal.",
			aSame: "/company-profile#/",
			linktext: "Aktivációs kód megadása"
		},
		{
			type: "default",
				img_url: "static/graphics/01_2perc_ebiz.png",
				h2: "HASZNOS TIPPEK - 2 PERC eBIZ",
				h3: "Szeretnénk, hogy egyszerűen, gyorsan és kényelmesen tudd intézni vállalkozásod pénzügyeit az eBIZ segítségével. Ezért mostantól heti egy tippel, hasznos funkcióval szeretnénk segíteni a munkádat.",
				p: "A \"2 perc eBIZ\" nevet adtuk a leveleknek, mivel rövidek és tömörek lesznek. Tetszik az ötlet? Kattints a Feliratkozom gombra, hogy hetente tudjuk küldeni Neked a tippeket, tanácsokat!",
				a: "http://eepurl.com/gxMXvz",
				linktext: "Feliratkozom"
		},
		{
			type: "default",
				img_url: "static/graphics/02_demo_videos.png",
				h2: "BEMUTATÓ VIDEÓK",
				h3: "Kíváncsi vagy hogyan működik az eBIZ? Szeretnéd látni a funkciókat működés közben?",
				p: "Folyamatosan bővülő listánkon összegyűjtöttük az eBIZ funkcióit bemutató oktató videókat!",
				a: "https://www.otpebiz.hu/bemutato-es-oktato-videok-demo-video/",
				linktext: "Tovább a videókhoz"
		},
		{
			type: "default",
				img_url: "static/graphics/03_faq.png",
				h2: "GY.I.K. - GYAKRAN ISMÉTELT KÉRDÉSEK",
				h3: "Elakadtál? Nem találsz valamit?",
				p: "Kérdések és válaszok, hogy az eBIZ használata gördülékeny legyen!",
				a: "https://www.otpebiz.hu/gyakran-ismetelt-kerdesek/",
				linktext: "Megnézem"
		},
		{
			type: "default",
				img_url: "static/graphics/04_updates.png",
				h2: "FOLYAMATOSAN FEJLESZTJÜK AZ eBIZ-T",
				h3: "Az eBIZ-t 2-4 hetente frissítjük újabb funkciókkal a Te és a többi felhasználó kérései, észrevételei alapján.",
				p: "A nagyobb, új funkciókat tartalmazó frissítéseket minden alkalommal összefoglaljuk blogunkban.",
				a: "https://www.otpebiz.hu/kategoriak/frissites/",
				linktext: "Tudj meg többet"
		},
		{
			type: "default",
			img_url: "static/graphics/05_free_einvoice.png",
			h2: "E-SZÁMLÁZZ INGYEN",
			h3: "Legyél „eBIZ hitelesített” felhasználó és e-számlázz ingyen! Tudj meg többet, hogy kihasználd az eBIZ nyújtotta lehetőségeket!",
			p: "Mutatjuk, mit kell tenned hozzá!",
			a: "https://www.otpebiz.hu/ingyenes-e-szamla-az-ebiz-ben/",
			linktext: "Bővebben"
		}
	],
	// NAVSLIDE: {
	// 	type: "nav",
	// 	img_url: "static/graphics/02_add_user.png",
	// 	h2: "NAV online adatszolgáltatás beállítása",
	// 	h3: "2018. július 1-től minden 100.000 Ft adótartalom feletti számláról online adatszolgáltatást kell küldeni a NAV-nak! ",
	// 	p: "Ezt a számlakiállítást követően az eBIZ rendszere automatikusan megoldja helyetted, ha beállítod az aláírókulcsod az eBIZ-be! A beállításhoz céged cégkapu hozzáférése szükséges.",
	// 	a1: "invoice#/nav-disclaimer",
	// 	a2: "https://www.otpebiz.hu/navreg",
	// 	linktext_1: "Beállítom most",
	// 	linktext_2: "Regisztráció lépésről lépésre"
	// },
	// COUPONSLIDE: {
	// 	type: "coupon",
	// 	img_url: "static/graphics/08_kupon.png",
	// 	text1: "Szolgáltató aktiválása",
	// 	text2: "Céged eBIZ fiókjához egyedi funkciók elérhetőek.",
	// 	text3: "Aktiváld a szolgáltatótól kapott aktivációs kódoddal.",
	// 	a1: "/company-profile#/",
	// 	a2: "",
	// 	linktext_1: "Aktivációs kód megadása",
	// 	linktext_2: "Később állítom be"
	// }
};

sliderdata.en = {
	DEFAULTSLIDES: [
		{
			type: "nav",
			img_url: "static/graphics/02_add_user.png",
			h2: "Setting NAV data provision",
			h3: "As of 1st of January 2021, data disclosure must be fulfilled to the National Tax and Customs Administration (NAV) on all invoices.",
			p: "After issuing an invoice, eBIZ is automatically providing data to NAV, if you set your signing key in eBIZ! To do the setting, you need your Client gateway (Company gateway) access.",
			a: "invoice#/nav-disclaimer",
			a2: "https://www.otpebiz.hu/navreg",
			linktext: "Setting it now",
			linktext_2: "Registration step by step"
		},
		{
			type: "coupon",
			img_url: "static/graphics/08_kupon.png",
			h2: "Activating Supplyer",
			h3: "You can add unique functions to your company’s eBIZ account .<br /> Activate with your registration code, received from the provider.",
			a: "/company-profile#/",
			linktext: "Enter activation code"
		},
		{
			type: "default",
			img_url: "/static/graphics/01_2min_ebiz.png",
			h2: "USEFUL HINTS - 2 minutes eBIZ",
			h3: "Our mission is to support you to manage the financial and business operations of your company with eBIZ. Starting today we are issuing weekly hints and tips about eBIZ to keep you informed.",
			p: "Subscribe to our weekly newsletter called „2 minutes eBIZ”!",
			a: "http://eepurl.com/gxMXvz",
			linktext: "Subscribe"
		},
		{
			type: "default",
			img_url: "/static/graphics/02_demo_videos.png",
			h2: "Demo videos",
			h3: "Do you want to know, how eBIZ is working?",
			p2: "In our (constantly growing) list we collected the demo videos, introducing eBIZ’s functions!",
			a: "https://www.otpebiz.hu/bemutato-es-oktato-videok-demo-video/",
			linktext: "Continue to demo videos"
		},
		{
			type: "default",
			img_url: "/static/graphics/03_faq.png",
			h2: "F.A.Q. - FREQUENTLY ASKED QUESTIONS",
			h3: "Are you stuck? You can not find something?",
			p: "Questions and answers, to help you use eBIZ smoothly!",
			a: "https://www.otpebiz.hu/gyakran-ismetelt-kerdesek/",
			linktext: "Open"
		},
		{
			type: "default",
			img_url: "/static/graphics/04_updates.png",
			h2: "We constantly develop eBIZ",
			h3: "We add new functions to eBIZ constantly, reviewing the comments and requests of our users.",
			p: "We always publish our bigger developments and releases in our blog.",
			a: "https://www.otpebiz.hu/kategoriak/frissites/",
			linktext: "Learn more"
		},
		{
			type: "default",
			img_url: "static/graphics/05_free_einvoice.png",
			h2: "Issue e-invoices for free",
			h3: "You can be an „eBIZ certified user” and issue e-invoices for free! Learn more and use the options eBIZ is providing you!",
			p: "Here it is, what you have to do!",
			a: "https://www.otpebiz.hu/ingyenes-e-szamla-az-ebiz-ben/",
			linktext: "More details"
		}
	],
	// NAVSLIDE: {
	// 	type: "nav",
	// 	img_url: "static/graphics/02_add_user.png",
	// 	h2: "ANGOLUL NAV online adatszolgáltatás beállítása",
	// 	h3: "ANGOLUL 2018. július 1-től minden 100.000 Ft adótartalom feletti számláról online adatszolgáltatást kell küldeni a NAV-nak! ",
	// 	p: "ANGOLUL Ezt a számlakiállítást követően az eBIZ rendszere automatikusan megoldja helyetted, ha beállítod az aláírókulcsod az eBIZ-be! A beállításhoz céged cégkapu hozzáférése szükséges.",
	// 	a1: "invoice#/nav-disclaimer",
	// 	a2: "https://www.otpebiz.hu/navreg",
	// 	linktext_1: "ANGOLUL Beállítom most",
	// 	linktext_2: "ANGOLUL Regisztráció lépésről lépésre"
	// },
	// COUPONSLIDE: {
	// 	type: "coupon",
	// 	img_url: "static/graphics/08_kupon.png",
	// 	text1: "ANGOLUL Szolgáltató aktiválása",
	// 	text2: "ANGOLUL Céged eBIZ fiókjához egyedi funkciók elérhetőek.",
	// 	text3: "ANGOLUL Aktiváld a szolgáltatótól kapott aktivációs kódoddal.",
	// 	a1: "",
	// 	a2: "",
	// 	linktext_1: "ANGOLUL Aktivációs kód megadása",
	// 	linktext_2: "ANGOLUL Később állítom be"
	// }
};

sliderdata.de = {
	DEFAULTSLIDES: [
		{
			type: "nav",
			img_url: "static/graphics/02_add_user.png",
			h2: "NAV online adatszolgáltatás beállítása",
			h3: "2021. január 1-től minden kiállított számláról online adatszolgáltatást kell küldeni a NAV-nak! GER",
			p: "Ezt a számlakiállítást követően az eBIZ rendszere automatikusan megoldja helyetted, ha beállítod az aláírókulcsod az eBIZ-be! A beállításhoz ügyfélkapu hozzáférés szükséges. GER",
			a: "invoice#/nav-disclaimer",
			a2: "https://www.otpebiz.hu/navreg",
			linktext: "Beállítom most",
			linktext_2: "Regisztráció lépésről lépésre"
		},
		{
			type: "coupon",
			img_url: "static/graphics/08_kupon.png",
			h2: "Szolgáltató aktiválása",
			h3: "Céged eBIZ fiókjához egyedi funkciók elérhetőek.<br />  Aktiváld a szolgáltatótól kapott aktivációs kódoddal.",
			a: "/company-profile#/",
			linktext: "Aktivációs kód megadása"
		},
		{
			type: "default",
			img_url: "/static/graphics/01_2perc_ebiz.png",
			h2: "NÉMETÜL HASZNOS TIPPEK - 2 PERC eBIZ",
			h3: "NÉMETÜL Szeretnénk, hogy egyszerűen, gyorsan és kényelmesen tudd intézni vállalkozásod pénzügyeit az eBIZ segítségével. Ezért mostantól heti egy tippel, hasznos funkcióval szeretnénk segíteni a munkádat. ",
			p: "NÉMETÜL A \"2 perc eBIZ\" nevet adtuk a leveleknek, mivel rövidek és tömörek lesznek. Tetszik az ötlet? Kattints a Feliratkozom gombra, hogy hetente tudjuk küldeni Neked a tippeket, tanácsokat!",
			a: "http://eepurl.com/gxMXvz",
			linktext: "NÉMETÜL Feliratkozom"
		},
		{
			type: "default",
			img_url: "/static/graphics/02_demo_videos",
			h2: "NÉMETÜL BEMUTATÓ VIDEÓK",
			h3: "NÉMETÜL Kíváncsi vagy hogyan működik az eBIZ?",
			p2: "NÉMETÜL Folyamatosan bővülő listánkon összegyűjtöttük az eBIZ funkcióit bemutató oktató videókat!",
			a: "https://www.otpebiz.hu/bemutato-es-oktato-videok-demo-video/",
			linktext: "NÉMETÜL Tovább a videókhoz"
		},
		{
			type: "default",
			img_url: "/static/graphics/03_faq.png",
			h2: "NÉMETÜL GY.I.K. - GYAKRAN ISMÉTELT KÉRDÉSEK",
			h3: "NÉMETÜL Elakadtál? Nem találsz valamit?",
			p: "NÉMETÜL Kérdések és válaszok, hogy az eBIZ használata gördülékeny legyen!",
			a: "https://www.otpebiz.hu/gyakran-ismetelt-kerdesek/",
			linktext: "NÉMETÜL Megnézem"
		},
		{
			type: "default",
			img_url: "/static/graphics/04_updates",
			h2: "NÉMETÜL FOLYAMATOSAN FEJLESZTJÜK AZ eBIZ-T",
			h3: "NÉMETÜL Az eBIZ-t 2-4 hetente frissítjük újabb funkciókkal a Te és a többi felhasználó kérései, észrevételei alapján.",
			p: "NÉMETÜL A nagyobb, új funkciókat tartalmazó frissítéseket minden alkalommal összefoglaljuk blogunkban.",
			a: "https://www.otpebiz.hu/kategoriak/frissites/",
			linktext: "NÉMETÜL Tudj meg többet"
		},
		{
			type: "default",
			img_url: "static/graphics/05_free_einvoice.png",
			h2: "NÉMETÜL E-SZÁMLÁZZ INGYEN",
			h3: "NÉMETÜL Legyél „eBIZ hitelesített” felhasználó és e-számlázz ingyen! Tudj meg többet, hogy kihasználd az eBIZ nyújtotta lehetőségeket!",
			p: "NÉMETÜL Mutatjuk, mit kell tenned hozzá!",
			a: "https://www.otpebiz.hu/ingyenes-e-szamla-az-ebiz-ben/",
			linktext: "NÉMETÜL Bővebben"
		}
	],
	// NAVSLIDE: {
	// 	type: "nav",
	// 	img_url: "static/graphics/02_add_user.png",
	// 	h2: "NAV online adatszolgáltatás beállítása",
	// 	h3: "2018. július 1-től minden 100.000 Ft adótartalom feletti számláról online adatszolgáltatást kell küldeni a NAV-nak! ",
	// 	p: "Ezt a számlakiállítást követően az eBIZ rendszere automatikusan megoldja helyetted, ha beállítod az aláírókulcsod az eBIZ-be! A beállításhoz céged cégkapu hozzáférés szükséges.",
	// 	a1: "invoice#/nav-disclaimer",
	// 	a2: "https://www.otpebiz.hu/navreg",
	// 	linktext_1: "Beállítom most",
	// 	linktext_2: "Regisztráció lépésről lépésre"
	// },
	// COUPONSLIDE: {
	// 	type: "coupon",
	// 	img_url: "static/graphics/08_kupon.png",
	// 	text1: "Szolgáltató aktiválása",
	// 	text2: "Céged eBIZ fiókjához egyedi funkciók elérhetőek.",
	// 	text3: "Aktiváld a szolgáltatótól kapott aktivációs kódoddal.",
	// 	a1: "",
	// 	a2: "",
	// 	linktext_1: "Aktivációs kód megadása",
	// 	linktext_2: "Később állítom be"
	// }
};

export { sliderdata };
